// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 9ca3sE4gAMHXGHWcmrUodR
// Component: ADPFZyzqdW
import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import CanvasView from "../../CanvasView"; // plasmic-import: 7Fu6fQ1ynQ/component

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic_main.module.css"; // plasmic-import: 9ca3sE4gAMHXGHWcmrUodR/projectcss
import sty from "./PlasmicIFrame.module.css"; // plasmic-import: ADPFZyzqdW/css

export type PlasmicIFrame__VariantMembers = {};

export type PlasmicIFrame__VariantsArgs = {};
type VariantPropType = keyof PlasmicIFrame__VariantsArgs;
export const PlasmicIFrame__VariantProps = new Array<VariantPropType>();

export type PlasmicIFrame__ArgsType = {};
type ArgPropType = keyof PlasmicIFrame__ArgsType;
export const PlasmicIFrame__ArgProps = new Array<ArgPropType>();

export type PlasmicIFrame__OverridesType = {
  root?: p.Flex<"div">;
  canvasView?: p.Flex<typeof CanvasView>;
};

export interface DefaultIFrameProps {
  className?: string;
}

function PlasmicIFrame__RenderFunc(props: {
  variants: PlasmicIFrame__VariantsArgs;
  args: PlasmicIFrame__ArgsType;
  overrides: PlasmicIFrame__OverridesType;

  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(
    () =>
      Object.assign(
        {},

        props.args
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const currentUser = p.useCurrentUser?.() || {};

  return (
    <React.Fragment>
      {}

      <div
        data-plasmic-name={"root"}
        data-plasmic-override={overrides.root}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          projectcss.all,
          projectcss.root_reset,
          projectcss.plasmic_default_styles,
          projectcss.plasmic_mixins,
          projectcss.plasmic_tokens,
          sty.root
        )}
      >
        <CanvasView
          data-plasmic-name={"canvasView"}
          data-plasmic-override={overrides.canvasView}
          className={classNames("__wab_instance", sty.canvasView)}
        />
      </div>
    </React.Fragment>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "canvasView"],
  canvasView: ["canvasView"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  typeof PlasmicDescendants[T][number];
type NodeDefaultElementType = {
  root: "div";
  canvasView: typeof CanvasView;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicIFrame__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicIFrame__VariantsArgs;
    args?: PlasmicIFrame__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicIFrame__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicIFrame__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicIFrame__ArgProps,
          internalVariantPropNames: PlasmicIFrame__VariantProps
        }),
      [props, nodeName]
    );

    return PlasmicIFrame__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicIFrame";
  } else {
    func.displayName = `PlasmicIFrame.${nodeName}`;
  }
  return func;
}

export const PlasmicIFrame = Object.assign(
  // Top-level PlasmicIFrame renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    canvasView: makeNodeComponent("canvasView"),

    // Metadata about props expected for PlasmicIFrame
    internalVariantProps: PlasmicIFrame__VariantProps,
    internalArgProps: PlasmicIFrame__ArgProps,

    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicIFrame;
/* prettier-ignore-end */
